import { combineReducers } from 'redux'
import Users from './Users/DuckController'
import Login from './Login/DuckController'

export default combineReducers ({
    Users,
    Login
})


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers.tsx